module.exports = __webpack_public_path__ + "img/content (1).9ba14443.svg";